
import React from 'react';
//@ts-ignore
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/css/react-select-extension.css';
import 'assets/vendors/bootstrap-icons/bootstrap-icons.css';

import 'react-toastify/dist/ReactToastify.css';
import 'assets/css/style.css';
import { BrowserRouter } from 'react-router-dom';
import { Wrapper } from 'components/Wrapper';
import Home from 'pages/Home';
import RedirectOnError from 'errorHandlers/RedirectOnError';
import { ToastContainer } from 'react-toastify'


function App() {



  return (
    <BrowserRouter basename={process.env.REACT_APP_CONTEXT_PATH}>
      <RedirectOnError to='/'>
        <Wrapper>
          <Home />
        </Wrapper>
      </RedirectOnError>
      <ToastContainer
        position='bottom-left'
        theme='colored'

      />
    </BrowserRouter>
  );
}

export default App;
